import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UserActionsModule } from './user-actions/user-actions.module';

@NgModule({
  declarations: [
  ],
  entryComponents: [
  ],
  imports: [
    CommonModule,
    UserActionsModule,
  ]
})
export class OccurrencesModule { }
